const getSearchResultCol = ({ search_type, searchResultCard }) => {

  const html = `
    <div class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-12">
      ${searchResultCard}
    </div>
  `;
  return html;

}

const moneyFormatter = new Intl.NumberFormat('en-SG', {
  style: 'currency',
  currency: 'SGD',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

const numberFormatter = new Intl.NumberFormat('en-SG', {
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

const getSearchResultCard = ({ search_type, data }) => {

  // Keep for customisation
  return null;

  const renderImageOverlay = () => {
    let overlayBadges = [], overlayText = [];
    if (data.listing_source.includes('BUC')) {
      overlayBadges.push(`<img src="https://pngimg.com/d/under_construction_PNG61.png" height="40" width="40" class='m-2'>`);
    }
    if (data.availability.includes(10)) {
      overlayText.push(`<div class="bg-danger p-2">SOLD</div>`);
    }
    let info = [];
    if (overlayBadges.length > 0) {
      info.push(`<div style="z-index:2;position:relative;color:white;">${overlayBadges.join("")}</div>`);
    }
    if (overlayText.length > 0) {
      info.push(`
        <div style="z-index:1;position:absolute;inset:0;background-color:rgba(0,0,0,0.5);"></div>
        <div style="z-index:2;position:absolute;inset:0;color:white;" class="h-100 d-flex flex-column align-items-center justify-content-center">
          ${overlayText.join("")}
        </div>
      `);
    }
    return `
      <div style="position:absolute;inset:0;">
        ${info.join("") || ""}
      </div>
    `;
  }

  const renderImage = () => {
    if (data.featured_media_url__medium_large) {
      return `<img class="card-img-top" loading="lazy" src=${data.featured_media_url__medium_large}>`;
    }
  }

  const renderListingType = () => {
    return `<div class="tiny">${data.listing_type}</div>`;
  }

  const renderTitle = () => {
    return data.property_name;
  }

  const renderPrice = () => {
    if (data.price > 0) {
      return `
        <div class="d-flex flex-row gap-1">
          <div class="fw-bold">${moneyFormatter.format(data.price)}</div>
          <span class="rounded-0 border-0 text-dark fw-normal badge bg-light">${data.price_type}</span>
        </div>
      `;
    }
  }

  const renderSize = () => {
    let info = [];
    if (data.floor_area > 0) {
      info.push(`<div>${numberFormatter.format(data.floor_area)} ${data.floor_area_type}</div>`);
    }
    if (data.land_area > 0) {
      info.push(`<div>${numberFormatter.format(data.land_area)} ${data.land_area_type} (Land)</div>`);
    }
    if (info.length > 0) {
      return `<div class="d-flex flex-row gap-1">${info.join("")}</div>`;
    }
  }

  const renderBedBath = () => {
    let info = [];
    if (data.bedrooms > 0) {
      info.push(`<div>${data.bedrooms} Beds</div>`);
    }
    if (data.bathrooms > 0) {
      info.push(`<div>${data.bathrooms} Baths</div>`);
    }
    if (info.length > 0) {
      return `<div class="d-flex flex-row gap-1">${info.join("")}</div>`;
    }
  }

  const renderBadges = () => {
    let info = [];
    if (data.property_type) {
      info.push(`<span class="rounded-0 border-0 text-dark fw-normal badge bg-light">${data.property_type}</span>`);
    }
    if (data.location) {
      info.push(`<span class="rounded-0 border-0 text-dark fw-normal badge bg-light">${data.location}</span>`);
    }
    if (data.tenure) {
      info.push(`<span class="rounded-0 border-0 text-dark fw-normal badge bg-light">${data.tenure}</span>`);
    }
    if (info.length > 0) {
      return `<div class="d-flex flex-row flex-wrap align-items-start gap-1" style="margin-left: -0.5em;">${info.join("")}</div>`;
    }
  }

  const html = `
  <div class="h-100 cursor-pointer rounded-4 border-0 shadow card">
    <div class="position-relative">
      ${renderImageOverlay() || ""}
      ${renderImage() || ""}
    </div>
    <div class="d-flex flex-column gap-1 card-body">
      <div class="listing_type">${renderListingType() || ""}</div>
      <div class="listing_title fw-bold">${renderTitle() || ""}</div>
      <div class="listing_price">${renderPrice() || ""}</div>
      <div class="small d-flex flex-column gap-1">
        <div class="listing_size">${renderSize() || ""}</div>
        <div class="listing_bed_bath">${renderBedBath() || ""}</div>
      </div>
      <div class="listing_badges">${renderBadges() || ""}</div>
    </div>
  </div>
  `;

  return html;

}

const getSearchResultMapFeatureProps = ({ data }) => {

  return {
    type: 'marker',
    iconUrl: "https://akvkxwyx.elementor.cloud/wp-content/uploads/2025/10/red-map-marker.png",
  }

  const listing_source = data.listing_source?.[0];
  switch (listing_source) {
    case "transaction":
      return {
        type: 'marker',
        iconUrl: "https://akvkxwyx.elementor.cloud/wp-content/uploads/2025/10/black-map-marker.png",
      }
    case "market":
      return {
        type: 'marker',
        iconUrl: "https://akvkxwyx.elementor.cloud/wp-content/uploads/2025/10/blue-map-marker.png",
      }
    case "own":
    default:
      return {
        type: 'marker',
        iconUrl: "https://akvkxwyx.elementor.cloud/wp-content/uploads/2025/10/red-map-marker.png",
      }
  }

}

const getSearchResultColProps = ({ data }) => {

  return {
    xl: 3,
    lg: 4,
    md: 4,
    sm: 6,
    xs: 12,
  }

}

const getSearchResultCardProps = ({ data, search_type }) => {

  switch (search_type) {
    case "map": {
      const onClick = () => {
        window.open(data.link, '_blank');
      }
      return {
        className: "cursor-pointer",
        onClick: onClick,
      }
    }
    default:
      const onClick = () => {
        window.location.href = data.link;
      }
      return {
        className: "h-100 cursor-pointer rounded-4 border-0 shadow",
        onClick: onClick,
      }
      break;
  }

}

export {
  getSearchResultCol, getSearchResultCard,
  getSearchResultColProps, getSearchResultCardProps, getSearchResultMapFeatureProps
};
